import mainImage from "./assets/main.png";
import sideImage from "./assets/side.png";
import { Link} from 'react-router-dom';


export default function Home() {
  return (
    <div className="home">
      <div className="home-grid">
        {/* LEFT */}
        <div className="home-left">
          <h1 className="home-title">There is Always a Method 2</h1>

          <img
            src={mainImage}
            alt="Teaching"
            className="home-main-image"
          />

          <div className="home-links">
            <Link to="/students">Students</Link>
            <Link to="/teachers">Teachers</Link>
            <Link to="/allvideos">All Videos</Link>
          </div>
        </div>

        {/* RIGHT */}
        <div className="home-right">
          <div className="home-info">
            <strong>Mathematical Methods and Specialist Mathematics</strong>
            <p>
              Joe Ousby on teaching Calculus level students and answering
              External Examination Questions in Queensland
            </p>
          </div>

          <img
            src={sideImage}
            alt="Demonstration"
            className="home-side-image"
          />
        </div>
      </div>
    </div>
  );
}
